import "./LandingStyle.css";
import Landpage from "./landing_pic.png";

const LandingPage = () => (
  <div className="wrapper">
    <div className="row">
      <h1>
        <span className="heading-p1">Uni</span>
        <span className="heading-p2">Fam</span>
      </h1>
    </div>
    <div className="row2">
      <div className="info">
        <div className="action">
          Connect with your peers. <p></p>Find your fam today.
        </div>
        <a href="./signup">
          <button className="action-btn">Join Now</button>
        </a>
      </div>

      <img className="image" src={Landpage} alt="picture" />
    </div>
  </div>
);

export default LandingPage;
